import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import styles from './CartItemLayout.module.scss';

const CartItemLayout = {
    Container: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.Container, props.className)}>{props.children}</div>
    ),
    Bottom: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.Bottom, props.className)}>{props.children}</div>
    ),
    Separator: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.Separator, props.className)}>{props.children}</div>
    ),
    PricingLayout: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.PricingLayout, props.className)}>{props.children}</div>
    ),
    TotalPricing: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.TotalPricing, props.className)}>{props.children}</div>
    ),
    TotalPriceGroup: (props: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
        <div className={classNames(styles.TotalPriceGroup, props.className)}>{props.children}</div>
    ),
};

export default CartItemLayout;
